import { render, staticRenderFns } from "./Call.vue?vue&type=template&id=c3489156&scoped=true&"
import script from "./Call.js?vue&type=script&lang=js&"
export * from "./Call.js?vue&type=script&lang=js&"
import style0 from "./Call.scss?vue&type=style&index=0&id=c3489156&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3489156",
  null
  
)

export default component.exports